export default {
  // 搜索组件
  advanceFilter: {
    operator: {
      ge: '大于等于',
      belongTo: '在范围内',
      notBelongTo: '不在范围内',
      gt: '大于',
      lt: '小于',
      le: '小于等于',
      equal: '等于',
      notEqual: '不等于',
      between: '区间',
      countGt: '数量大于',
      countLt: '数量小于',
      empty: '为空',
      not_empty: '不为空',
      contains: '包含',
      not_contains: '不包含',
      dynamics: '动态',
      betweenFixed: '固定',
    },
    common: {
      today: '今天',
      yesterday: '昨天',
      tomorrow: '明天',
      thisWeek: '本周',
      lastWeek: '上周',
      nextWeek: '下周',
      thisMonth: '本月',
      lastMonth: '上月',
      nextMonth: '下月',
      lastSevenDays: '过去7天内',
      nextSevenDays: '未来7天内',
      lastThirtyDays: '过去30天',
      nextThirtyDays: '未来30天',
      lastSixtyDays: '过去60天',
      nextSixtyDays: '未来60天',
      thisQuarter: '本季度',
      lastQuarter: '上季度',
      nextQuarter: '下季度',
      thisYear: '本年度',
      lastYear: '上年度',
      nextYear: '下年度',
      custom: '自定义',
      day: '天前',
      afterDay: '天后',
      week: '周前',
      afterWeek: '周后',
      month: '月前',
      afterMonth: '月后',
    },
  },
  // 筛选
  Filter: {
    DisplayList: '在列表中展示',
    HideList: '在列表中隐藏',
    Freeze: '冻结',
    notFreeze: '不冻结',
    frontToBack: '从前往后',
    backToFront: '从后往前',
    Beforefreezing: '冻结前',
    Afterfreezing: '冻结后',
    Column: '列',

    //
    AdvancedFilter: '高级筛选',
    Addcondition: '添加条件',
  },
};
